module.exports = __webpack_public_path__ + "static/buenasNoches-5a27253ac9e7a622b25459f2002a4560.webp";